import { Helmet } from "react-helmet";
import MutualFundHero from "../home/MutualFundHero";
import MutualFundCategories from "../home/MutualFundCategories";
import MutualFundSteps from "../home/MutualFundSteps";
import MutualFundGoalsInsights from "../home/MutualFundGoalsInsights";
import MutualFundFeatured from "../home/MutualFundFeatured";

export default function MutualFund() {
  return (
    <>
      <Helmet>
        <title>GPS Finvest - Mutual Funds</title>
        <meta
          name="description"
          content="Explore GPS Finvest Mutual Funds. Invest smartly with expert guidance and diversify your portfolio for long-term financial growth."
        />
      </Helmet>

      <MutualFundHero />
      <MutualFundCategories />
      <MutualFundSteps />
      <MutualFundGoalsInsights />
      <MutualFundFeatured />
    </>
  );
}
